import { useEffect, useState } from 'react'

/**
 * Debounce a value: the returned value only updates after `delay` ms
 * have passed without the input value changing. Drop-in replacement for
 * react-storefront/utils/useDebounce.
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(handler)
  }, [value, delay])

  return debouncedValue
}
